import { IPersonName } from './IPersonName';
import { IIdentificationInfo } from './IIdentificationInfo';
import { IAddressWithoutIndex } from './IAddressWithoutIndex';
import { ITelephone } from './ITelephone';
import { IEmail } from './IEmail';
import { ILoyaltyProgram} from './ILoyaltyProgram';

export interface IUserProfile {
    id: number,
    personName: IPersonName, // required
    branch?: string,
    rank?: string,
    identificationInfo?: IIdentificationInfo[],
    addresses?: IAddressWithoutIndex[],
    telephones?: ITelephone[],
    emails?: IEmail[],
    loyaltyProgram?: ILoyaltyProgram,
}

enum AddressType {
    PERSONAL = 1,
    BUSINSS = 2,
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/HotelReservationV2/IUserProfile-IV2.ts